import { render } from "./ApproveLiquidation.vue?vue&type=template&id=27da618c"
import script from "./ApproveLiquidation.vue?vue&type=script&lang=js"
export * from "./ApproveLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__